import { InstanceInfo } from './InstanceInfo';
import { ClassInfo } from './ClassInfo';
var MethodInfo = /** @class */ (function () {
    function MethodInfo(abc, _index, name, returnTypeNameIndex, parameters, optionalCount, flags) {
        this.abc = abc;
        this._index = _index;
        this.name = name;
        this.returnTypeNameIndex = returnTypeNameIndex;
        this.parameters = parameters;
        this.optionalCount = optionalCount;
        this.flags = flags;
        this.trait = null;
        this.scriptInfo = null;
        this.classInfo = null;
        this.instanceInfo = null;
        this.isConstructor = false;
        this.compiled = null;
        this.error = null;
        this.useCount = 0;
        this._body = null;
        this.minArgs = parameters.length - optionalCount;
    }
    Object.defineProperty(MethodInfo.prototype, "state", {
        get: function () {
            if (this.error || this.getBody() == null) {
                return "failed" /* FAILED */;
            }
            if (this.compiled) {
                return "compiled" /* COMPILLED */;
            }
            return "pending" /* PENDING */;
        },
        enumerable: true,
        configurable: true
    });
    MethodInfo.prototype.getNativeMetadata = function () {
        if (!this.trait) {
            return null;
        }
        var metadata = this.trait.getMetadata();
        if (!metadata) {
            return null;
        }
        for (var i = 0; i < metadata.length; i++) {
            if (metadata[i].getName() === 'native') {
                return metadata[i];
            }
        }
        return null;
    };
    MethodInfo.prototype.getBody = function () {
        return this._body || (this._body = this.abc.getMethodBodyInfo(this._index));
    };
    MethodInfo.prototype.index = function () {
        return this._index;
    };
    MethodInfo.prototype.getTypeName = function () {
        if (this._retunTypeName !== undefined) {
            return this._retunTypeName;
        }
        if (this.returnTypeNameIndex === 0) {
            this._retunTypeName = null;
        }
        else {
            this._retunTypeName = this.abc.getMultiname(this.returnTypeNameIndex);
        }
        return this._retunTypeName;
    };
    MethodInfo.prototype.getType = function () {
        if (this._returnType !== undefined) {
            return this._returnType;
        }
        if (this.returnTypeNameIndex === 0) {
            this._returnType = null;
        }
        else {
            var mn = this.abc.getMultiname(this.returnTypeNameIndex);
            this._returnType = this.abc.applicationDomain.getClass(mn);
        }
        return this._returnType;
    };
    MethodInfo.prototype.getName = function () {
        if (typeof this.name === 'number') {
            return this.abc.getString(this.name) || 'anonymous';
        }
        if (this.trait) {
            return this.trait.getName().name;
        }
        return 'anonymous';
    };
    MethodInfo.prototype.toString = function () {
        var str = 'anonymous';
        if (this.name) {
            str = this.abc.getString(this.name);
        }
        str += ' (' + this.parameters.join(', ') + ')';
        if (this.returnTypeNameIndex) {
            str += ': ' + this.abc.getMultiname(this.returnTypeNameIndex).name;
        }
        return str;
    };
    MethodInfo.prototype.toFlashlogString = function () {
        var trait = this.trait;
        var prefix = trait.kind === 2 /* Getter */ ? 'get ' :
            trait.kind === 3 /* Setter */ ? 'set ' : '';
        var name = trait.toFlashlogString();
        var holder = trait.holder;
        var holderName;
        if (holder && holder instanceof InstanceInfo) {
            holderName = holder.toFlashlogString();
            prefix = holderName + '/' + prefix;
        }
        if (holder && holder instanceof ClassInfo && holder.trait) {
            holderName = holder.trait.toFlashlogString();
            prefix = holderName + '$/' + prefix;
        }
        var prefixPos;
        if (holderName && (prefixPos = name.indexOf('::')) > 0 &&
            holderName.indexOf(name.substring(0, prefixPos + 2)) === 0) {
            name = name.substring(prefixPos + 2);
        }
        return 'MTHD ' + prefix + name + ' ()';
    };
    MethodInfo.prototype.isNative = function () {
        return !!(this.flags & 32 /* Native */);
    };
    MethodInfo.prototype.needsRest = function () {
        return !!(this.flags & 4 /* NeedRest */);
    };
    MethodInfo.prototype.needsArguments = function () {
        return !!(this.flags & 1 /* NeedArguments */);
    };
    return MethodInfo;
}());
export { MethodInfo };
